// extracted by mini-css-extract-plugin
module.exports = {"base":"InstagramButton_base__jMAm5","base-inner":"InstagramButton_base-inner__vjCfx","text":"InstagramButton_text__OUkfI","add-friend":"InstagramButton_add-friend__NPx1X"};